import { useState } from 'react';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export default function TestSurveySubmit() {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testSubmit = async () => {
    setLoading(true);
    setResult('Testing...');
    
    try {
      const token = localStorage.getItem('auth_token');
      
      const testData = {
        q1_email: "test@example.com",
        q2_profession: "General Dentist",
        q3_years_practicing: "5–10 years",
        q4_practice_type: "Solo private practice",
        q5_course_objectives: 5,
        q6_instructor_knowledge: 5,
        q7_material_quality: 4,
        q8_relevance: 5,
        q9_understanding_improvement: 4,
        q10_presentation_effectiveness: 5,
        q11_dentoalveolar_surgery: true,
        q11_third_molar_surgery: false,
        q11_oral_pathology: true,
        q11_dental_implants: false,
        q11_surgical_complications: false,
        q11_bone_grafting: false,
        q11_sedation_anesthesia: false,
        q12_content_level: "Intermediate",
        q13_preferred_day: "Weekdays",
        q14_preferred_time: "Morning",
        q15_learning_format: "Online/webinar",
        q16_networking_interest: "Yes",
        q17_cost_factor: "No",
        q18_team_training_interest: "Yes",
        q19_most_valuable_aspect: "Great content",
        q20_suggested_changes: "None",
        q21_other_feedback: "Excellent course",
        course_id: "test-course-123",
        course_title: "Test Course"
      };

      const response = await fetch(`${API}/api/course-survey`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(testData)
      });

      const text = await response.text();
      setResult(`Status: ${response.status}\nResponse: ${text}`);
      
    } catch (error) {
      setResult(`Error: ${error.message}\n${error.stack}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Test Survey Submission</h1>
      <Button onClick={testSubmit} disabled={loading}>
        {loading ? 'Testing...' : 'Test Submit Survey'}
      </Button>
      <pre className="mt-4 p-4 bg-gray-100 rounded whitespace-pre-wrap">
        {result}
      </pre>
    </div>
  );
}
